var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.284,
    height: 24.105,
    viewBox: "0 0 19.284 24.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_13",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 13",
    d: "M19.668,2H5.205A1.205,1.205,0,0,0,4,3.205V22.489a1.205,1.205,0,0,0,1.205,1.205H6.411V24.9a1.205,1.205,0,0,0,1.205,1.205h0A1.205,1.205,0,0,0,8.821,24.9V23.695H19.668a3.616,3.616,0,0,0,3.616-3.616V5.616A3.616,3.616,0,0,0,19.668,2ZM16.053,21.284H6.411V4.411h9.642Zm4.821-1.205a1.205,1.205,0,0,1-1.205,1.205H18.463V4.411h1.205a1.205,1.205,0,0,1,1.205,1.205Z",
    transform: "translate(-4 -2)",
    fill: "#92929d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.f4840b3b.svg";
export { ForwardRef as ReactComponent };